import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Box, Divider, HStack, Heading, Link, Stack, Text, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';

var Avatars = function Avatars(_ref) {
  var publishers = _ref.publishers;
  return /*#__PURE__*/_jsx(HStack, {
    children: publishers.map(function (publisher) {
      return /*#__PURE__*/_jsx(Tooltip, {
        label: publisher.name,
        "aria-label": "Publisher name",
        children: /*#__PURE__*/_jsx(Avatar, {
          src: publisher.avatar_url,
          name: publisher.name,
          size: 'lg'
        })
      }, publisher.id);
    })
  });
};

var Article = function Article(props) {
  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  var handleToggle = function handleToggle() {
    return setShow(!show);
  };

  var months = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var publication = props.article.journal_name || props.article.source_name || props.article.publisher_name;
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsxs(Text, {
      color: useColorModeValue('gray.600', 'gray.400'),
      children: [months[props.article.publication_month], ' ', props.article.publication_year, ' ', publication ? "\u2022 ".concat(publication) : null]
    }), /*#__PURE__*/_jsx(Heading, {
      as: "h2",
      fontSize: "lg",
      children: /*#__PURE__*/_jsx(Link, {
        href: props.article.publication_url,
        target: "_blank",
        children: props.article.title
      })
    }), /*#__PURE__*/_jsx(Text, {
      color: useColorModeValue('gray.600', 'gray.400'),
      children: (props.article.authors || []).join(', ')
    }), /*#__PURE__*/_jsx(Avatars, {
      publishers: props.article.publishers
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Text, {
        noOfLines: show ? undefined : 4,
        color: useColorModeValue('gray.600', 'gray.400'),
        children: props.article["abstract"]
      }), /*#__PURE__*/_jsxs(Link, {
        variant: "link",
        onClick: handleToggle,
        color: "blue.500",
        children: ["Show ", show ? 'less' : 'more']
      })]
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
};

export var ArticlesList = function ArticlesList(props) {
  return /*#__PURE__*/_jsx(Stack, {
    spacing: 8,
    children: props.articles.map(function (a) {
      return /*#__PURE__*/_jsx(Article, {
        article: a
      }, a.id);
    })
  });
};
export default ArticlesList;